import React from "react";

function HeaderFilters({
    title = "Datos Básicos",
    subtitle = "Panel General",

    regions = [],
    distys = [],
    grados = [],

    regionId = "",
    distyId = "",
    gradoId = "",

    startDate = "",
    endDate = "",

    onRegionChange,
    onDistyChange,
    onGradoChange,
    onStartDateChange,
    onEndDateChange,
}) {
    return (
        <div className="row">
            <div className="d-flex justify-content-end align-items-center flex-wrap mb-4 gap-3">
                <div className="row g-2 align-items-end w-100">
                    <div className="col-md-3">
                        <h3>{title}</h3>
                        <p className="text-primary mb-0">{subtitle}</p>
                    </div>

                    <div className="col-md-2">
                        <label className="form-label mb-1">Región</label>
                        <select
                            className="form-select"
                            value={String(regionId)}
                            onChange={(e) => onRegionChange?.(e.target.value)}
                        >
                            <option value="">Todas</option>

                            {regions.map((region) => (
                                <option
                                    key={region.Region_ID}
                                    value={String(region.Region_ID)}
                                >
                                    {region.Region_Nombre}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-2">
                        <label className="form-label mb-1">Disty</label>
                        <select
                            className="form-select"
                            value={String(distyId)}
                            onChange={(e) => onDistyChange?.(e.target.value)}
                        >
                            <option value="">Todos</option>

                            {distys.map((disty) => (
                                <option
                                    key={disty.Disty_ID}
                                    value={String(disty.Disty_ID)}
                                >
                                    {disty.Disty_Nombre}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-1">
                        <label className="form-label mb-1">Grado</label>
                        <select
                            className="form-select"
                            value={String(gradoId)}
                            onChange={(e) => onGradoChange?.(e.target.value)}
                        >
                            <option value="">Todos</option>

                            {grados.map((grado) => (
                                <option
                                    key={grado.Grado_ID}
                                    value={String(grado.Grado_ID)}
                                >
                                    {grado.Grado_Nombre}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-2">
                        <label className="form-label mb-1">Inicio</label>
                        <input
                            type="date"
                            className="form-control"
                            value={startDate}
                            min="2026-05-11"
                            onChange={(e) => onStartDateChange?.(e.target.value)}
                        />
                    </div>

                    <div className="col-md-2">
                        <label className="form-label mb-1">Fin</label>
                        <input
                            type="date"
                            className="form-control"
                            value={endDate}
                            onChange={(e) => onEndDateChange?.(e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeaderFilters;